import { forwardRef } from 'react';

function Image({ alt = '', ...props }, ref) {
  return <img ref={ref} alt={alt} {...props} />;
}

export default forwardRef(Image);
